import { Text, Image } from '@/ui'
import { TAX_PROFILE_STEP, useTaxProfileSteps } from './helpers'
import { TaxProfileFormFooter } from './TaxProfileFormFooter'
import {
  TaxProfileAccordions,
  useTaxProfileAccordionCopy,
} from './TaxProfileAccordions'
import { TypographyStyles } from '@/styles'

export const PersonalTaxIncomeIntro = () => {
  const { goToPreviousStep, goToNextStep } = useTaxProfileSteps(
    TAX_PROFILE_STEP.personalTaxIncomeIntro
  )

  const faqCopy = useTaxProfileAccordionCopy()

  return (
    <div className="flex flex-col items-center gap-6 max-w-3xl mx-auto">
      <Image
        src="https://heard-images.s3.amazonaws.com/assets/orange_paystub.svg"
        alt="Paystub"
        className="w-[120px] h-[120px]"
      />
      <Text
        className="w-full text-center px-4"
        variant={TypographyStyles.DISPLAY_LG}
      >
        Next, we’ll ask you to enter your taxable income.
      </Text>

      <Text
        className="w-full text-center px-4 mb-4"
        variant={TypographyStyles.BODY_LG}
      >
        If you have W-2 income, we recommend grabbing your{' '}
        <b>most recent paystub</b> for this step.
      </Text>

      <div className="w-full">
        <TaxProfileAccordions
          faqs={[
            faqCopy.canUseOldPaystub,
            faqCopy.whereFindOldPaystub,
            faqCopy.whatIfDoNotEarnW2,
          ]}
        />
      </div>

      <div className="w-full">
        <TaxProfileFormFooter
          submitOrContinue={() => goToNextStep()}
          goToPreviousStep={goToPreviousStep}
        />
      </div>
    </div>
  )
}
